import React from "react";
import Flexbox from "flexbox-react";
import "./MyAssessmentView.css";
import { Divider } from "@blueprintjs/core";
import CurrentUserStore from "../../stores/CurrentUserStore";
import { isGoalProgressSpecialAccount } from "../../utils/goalProgressUtils.js";

const ManagerContainerIntroBox = ({ iconType = "self", text, description, isMultiLevelReview, rating, ratingLabel, ratingLabels = [], resultData, finalAssessmentRatingLabel, finalGoalRatingLabel, containerType = "assessment", isRatingEnabledQuestions, managerCombinedRating, managerCombinedRatingLabel, managerGlobalRating, managerGlobalRatingLabel }) => {
  const getIcon = () => {
    if (iconType === "manager") {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path d="M21.6663 14.0832C21.6663 19.4998 17.8747 22.2082 13.368 23.779C13.132 23.859 12.8757 23.8551 12.6422 23.7682C8.12467 22.2082 4.33301 19.4998 4.33301 14.0832V6.49984C4.33301 6.21252 4.44714 5.93697 4.65031 5.7338C4.85347 5.53064 5.12902 5.4165 5.41634 5.4165C7.58301 5.4165 10.2913 4.1165 12.1763 2.46984C12.4059 2.27375 12.6978 2.16602 12.9997 2.16602C13.3015 2.16602 13.5935 2.27375 13.823 2.46984C15.7188 4.12734 18.4163 5.4165 20.583 5.4165C20.8703 5.4165 21.1459 5.53064 21.349 5.7338C21.5522 5.93697 21.6663 6.21252 21.6663 6.49984V14.0832Z" stroke="#1870D5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.90723 20.486C7.3695 19.2425 8.20118 18.1703 9.29059 17.4132C10.38 16.6562 11.675 16.2506 13.0016 16.251C14.3282 16.2513 15.6229 16.6576 16.7119 17.4152C17.8009 18.1728 18.632 19.2455 19.0936 20.4892" stroke="#1870D5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.0003 16.2502C15.3936 16.2502 17.3337 14.3101 17.3337 11.9168C17.3337 9.5236 15.3936 7.5835 13.0003 7.5835C10.6071 7.5835 8.66699 9.5236 8.66699 11.9168C8.66699 14.3101 10.6071 16.2502 13.0003 16.2502Z" stroke="#1870D5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    } else {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none">
          <path d="M11.5 15H7C5.93913 15 4.92172 15.4214 4.17157 16.1716C3.42143 16.9217 3 17.9391 3 19V21" stroke="#1870D5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M21.378 16.6261C21.7763 16.2278 22.0001 15.6875 22.0001 15.1241C22.0001 14.5608 21.7763 14.0205 21.378 13.6221C20.9796 13.2238 20.4393 13 19.876 13C19.3126 13 18.7723 13.2238 18.374 13.6221L14.364 17.6341C14.1262 17.8718 13.9522 18.1655 13.858 18.4881L13.021 21.3581C12.9959 21.4442 12.9944 21.5354 13.0166 21.6222C13.0389 21.7091 13.084 21.7883 13.1474 21.8517C13.2108 21.9151 13.2901 21.9603 13.3769 21.9825C13.4637 22.0048 13.5549 22.0032 13.641 21.9781L16.511 21.1411C16.8336 21.0469 17.1274 20.8729 17.365 20.6351L21.378 16.6261Z" stroke="#1870D5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M10 11C12.2091 11 14 9.20914 14 7C14 4.79086 12.2091 3 10 3C7.79086 3 6 4.79086 6 7C6 9.20914 7.79086 11 10 11Z" stroke="#1870D5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    }
  };

  const formatRating = (value, decimals = 2) => {
    if (value === undefined || value === null || value === "") return "";
    const num = Number(value);
    if (isNaN(num)) return "";
    return num.toFixed(decimals);
  };

  const formattedFinalRating =
    resultData !== undefined && resultData !== null && resultData !== ""
      ? Number(resultData).toFixed(2)
      : "";

  const formattedAssessmentRating =
    rating !== undefined && rating !== null && rating !== ""
      ? Number(rating).toFixed(2)
      : "";

  const isSpecialAccount = isGoalProgressSpecialAccount(CurrentUserStore?.activeAccount?.accountId);

  const labelFromApi = (value) => {
    const num = Number(value);
    if (!Array.isArray(ratingLabels) || ratingLabels.length === 0 || Number.isNaN(num)) return "";
    const firstValue = Number(ratingLabels[0].value);
    if (!Number.isNaN(firstValue) && num <= firstValue - 0.5) return ratingLabels[0].label;
    for (const item of ratingLabels) {
      const v = Number(item.value);
      if (Number.isNaN(v)) continue;
      if (num >= v - 0.5 && num < v + 0.5) return item.label;
    }
    return ratingLabels[ratingLabels.length - 1]?.label || "";
  };

  const fallbackLabelFor = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return "";
    const rounded = Math.round(num);
    if (rounded === 1) return "Not Met";
    if (rounded === 2) return "Partially Met";
    if (rounded === 3) return "Met";
    return "";
  };

  const finalLabelToShow =
    containerType === "goal"
      ? (finalGoalRatingLabel || finalAssessmentRatingLabel)
      : (finalAssessmentRatingLabel || finalGoalRatingLabel);

  const hasFinalRating =
    containerType === "assessment" && !!formattedFinalRating;

  return (

    <Flexbox
      flexDirection="row"
      alignItems="center"
      // justifyContent="space-between"
      className="intro-container"
      width="100%"
    >

      <Flexbox flexDirection="column" width="100%">
        {/* upper icon + title */}
        <Flexbox flexDirection="row" alignItems="center" gap="16px">
          <div className="intro-icon-container">
            {getIcon()}
          </div>
          <Flexbox flexDirection="column" style={{ paddingLeft: "10px" }}>
            <p className="container-intro-text">{text}</p>
            <p className="container-intro-description">{description}</p>
          </Flexbox>
        </Flexbox>

        {/* ratings: Final Rating only for assessment container, then Assessment/Goal Rating */}
        <Flexbox
          flexDirection="column"
          className="push-10-t push-10-b"
        >



          {(isMultiLevelReview && managerGlobalRating) ? (
            <>
              <Flexbox
                flexDirection="row"
                alignItems="baseline"
                justifyContent="space-between"
                className="intro-rating-row push-10-t"
              >
                <span className="intro-rating-label">Final Rating</span>
                <div className="intro-rating-pill">
                  {!isSpecialAccount && (
                    <span className="intro-rating-value">{formatRating(managerGlobalRating)}</span>
                  )}
                  {(managerGlobalRatingLabel || (isSpecialAccount ? (labelFromApi(managerGlobalRating) || fallbackLabelFor(managerGlobalRating)) : "")) && (
                    <span className="rating-chip">
                      {managerGlobalRatingLabel || labelFromApi(managerGlobalRating) || fallbackLabelFor(managerGlobalRating)}
                    </span>
                  )}
                </div>
              </Flexbox>
              <Divider style={{ marginTop: "30px", marginBottom: "18px" }} className="question-divider" />
            </>
          ) : null}

          {managerCombinedRating && (
            <>
              <Flexbox
                flexDirection="row"
                alignItems="baseline"
                justifyContent="space-between"
                className="intro-rating-row push-10-t"
              >
                <span className="intro-rating-label">{isMultiLevelReview ? "Manager Rating" : "Final Rating"}</span>
                <div className="intro-rating-pill">
                  {!isSpecialAccount && (
                    <span className="intro-rating-value">{formatRating(managerCombinedRating)}</span>
                  )}
                  {(managerCombinedRatingLabel || (isSpecialAccount ? (labelFromApi(managerCombinedRating) || fallbackLabelFor(managerCombinedRating)) : "")) && (
                    <span className="rating-chip">
                      {managerCombinedRatingLabel || labelFromApi(managerCombinedRating) || fallbackLabelFor(managerCombinedRating)}
                    </span>
                  )}
                </div>
              </Flexbox>
              {!isMultiLevelReview &&
                <Divider style={{ marginTop: "30px", marginBottom: "18px" }} className="question-divider" />
              }
            </>

          )}


          {!(containerType === "assessment" && isRatingEnabledQuestions !== 1) && formattedAssessmentRating && (
            <Flexbox
              flexDirection="row"
              alignItems="baseline"
              justifyContent="space-between"
              className="intro-rating-row"
            >
              <span className="intro-rating-label">
                {containerType === "assessment" ? "Assessment" : "Goal"} Rating
              </span>
              <div className="intro-rating-pill">
                {!isSpecialAccount && (
                  <span className="intro-rating-value">{formattedAssessmentRating}</span>
                )}
                {(ratingLabel || (isSpecialAccount ? (labelFromApi(formattedAssessmentRating) || fallbackLabelFor(formattedAssessmentRating)) : "")) && (
                  <span className="rating-chip">
                    {ratingLabel || labelFromApi(formattedAssessmentRating) || fallbackLabelFor(formattedAssessmentRating)}
                  </span>
                )}
              </div>
            </Flexbox>
          )}
        </Flexbox>

      </Flexbox>

    </Flexbox>
  );
};

export default ManagerContainerIntroBox;


